// Records
export const GROUP_RECORDS_SITE : string = "GROUP_site_records";
export const GROUP_RECORDS_SITE_MANAGER : string = "GROUP_site_records_SiteManager";
export const GROUP_RECORDS_SITE_COLLABORATOR : string = "GROUP_site_records_SiteCollaborator";
export const GROUP_RECORDS_SITE_CONTRIBUTOR : string = "GROUP_site_records_SiteContributor";
export const GROUP_RECORDS_SITE_CONSUMER : string = "GROUP_site_records_SiteConsumer";

// Transfers
export const GROUP_TRANSFERS_SITE : string = "GROUP_site_transfers";
export const GROUP_TRANSFERS_SITE_MANAGER : string = "GROUP_site_transfers_SiteManager";
export const GROUP_TRANSFERS_SITE_COLLABORATOR : string = "GROUP_site_transfers_SiteCollaborator";
export const GROUP_TRANSFERS_SITE_CONTRIBUTOR : string = "GROUP_site_transfers_SiteContributor";
export const GROUP_TRANSFERS_SITE_CONSUMER : string = "GROUP_site_transfers_SiteConsumer";

// Transfer calendar
export const GROUP_TRANSFER_CALENDAR_SITE : string = "GROUP_site_transfer-calendar";
export const GROUP_TRANSFER_CALENDAR_SITE_MANAGER : string = "GROUP_site_transfer-calendar_SiteManager";
export const GROUP_TRANSFER_CALENDAR_SITE_COLLABORATOR : string = "GROUP_site_transfer-calendar_SiteCollaborator";
export const GROUP_TRANSFER_CALENDAR_SITE_CONTRIBUTOR : string = "GROUP_site_transfer-calendar_SiteContributor";
export const GROUP_TRANSFER_CALENDAR_SITE_CONSUMER : string = "GROUP_site_transfer-calendar_SiteConsumer";

// Loans
export const GROUP_LOANS_SITE : string = "GROUP_site_loans";
export const GROUP_LOANS_SITE_MANAGER : string = "GROUP_site_loans_SiteManager";
export const GROUP_LOANS_SITE_COLLABORATOR : string = "GROUP_site_loans_SiteCollaborator";
export const GROUP_LOANS_SITE_CONTRIBUTOR : string = "GROUP_site_loans_SiteContributor";
export const GROUP_LOANS_SITE_CONSUMER : string = "GROUP_site_loans_SiteConsumer";

// Administracion
export const GROUP_ADMINISTRATION_SITE : string = "GROUP_site_administracion";
export const GROUP_ADMINISTRATION_SITE_MANAGER : string = "GROUP_site_administracion_SiteManager";
export const GROUP_ADMINISTRATION_SITE_COLLABORATOR : string = "GROUP_site_administracion_SiteCollaborator";
export const GROUP_ADMINISTRATION_SITE_CONTRIBUTOR : string = "GROUP_site_administracion_SiteContributor";
export const GROUP_ADMINISTRATION_SITE_CONSUMER : string = "GROUP_site_administracion_SiteConsumer";

// BOUD
export const GROUP_BOUD_SITE : string = "GROUP_site_boud";
export const GROUP_BOUD_SITE_MANAGER : string = "GROUP_site_boud_SiteManager";
export const GROUP_BOUD_SITE_COLLABORATOR : string = "GROUP_site_boud_SiteCollaborator";
export const GROUP_BOUD_SITE_CONTRIBUTOR : string = "GROUP_site_boud_SiteContributor";
export const GROUP_BOUD_SITE_CONSUMER : string = "GROUP_site_boud_SiteConsumer";

export const GROUP_GESTORDOCUMENTAL_BOUDPUB : string = "GROUP_GESTORDOCUMENTAL_BOUDPUB";
export const GROUP_BOUDPUB : string = "GROUP_BOUDPUB";
export const GROUP_BOUDED : string = "GROUP_BOUDED";

// ARCHIVO
export const GROUP_ARCHIVERO : string = "GROUP_ARCHIVERO";
export const GROUP_OPERADOR : string = "GROUP_OPERADOR";
export const GROUP_ADMIN : string = "GROUP_ADMINISTRADOR";

// URLs
export const ADMINISTRATION_DATA_LIST_SITE_URL : string = "/share/page/site/administracion/data-lists";

// TYPES
export const SITE_TYPE : string = "st:site";
export const UDEU_RECORD_TYPE : string = "udeu:record";
export const UDEU_TRANSFER_CALENDAR_TYPE : string = "udeu:transferCalendar";
export const UDEU_TRANSFER_TYPE : string = "udeu:transfer";
export const UDEU_LOANS_TYPE : string = "udeu:loan";
export const UDEU_BOUD_TYPE : string = "udeu:boudElement";

// ASPECTS AND PROPERTIES
export const SYS_NODE_UUID_PROP : string = "sys:node-uuid";

export const CM_TITLE_PROP : string = "cm:title";

export const UDEU_STRUCTURAL_FOLDER_ASPECT : string = "udeu:structuralFolderAsp";
export const UDEU_STRUCTURAL_FOLDER_NAME_PROP : string = "udeu:structuralFolderName";

export const UDEU_RECORD_DRAFT_ASPECT : string = "udeu:recordDraft";

export const UDEU_DIGITAL_ASPECT : string = "udeu:digital";

export const UDEU_AUTHOR_ASPECT : string = "udeu:authorAsp";
export const UDEU_AUTHOR_RIA_PROP : string = "udeu:authorRIA";
export const UDEU_AUTHOR_NAME_PROP : string = "udeu:authorName";
export const UDEU_AUTHOR_LASTNAME1_PROP : string = "udeu:authorLastname1";
export const UDEU_AUTHOR_LASTNAME2_PROP : string = "udeu:authorLastname2";

export const UDEU_LOCATION_ASPECT : string = "udeu:locationAsp";
export const UDEU_LOCATION_DOCUMENT_PROP : string = "udeu:locationDocument";
export const UDEU_LOCATION_DEPOSIT_PROP : string = "udeu:locationDeposit";
export const UDEU_LOCATION_INSTALLATION_UNIT_PROP : string = "udeu:locationInstallationUnit";
export const UDEU_LOCATION_SIGNATURA_PROP : string = "udeu:locationSignatura";

export const UDEU_FILE_ASPECT : string = "udeu:fileAsp";

export const UDEU_STATUS_ASPECT : string = "udeu:statusAsp";
export const UDEU_STATUS_PROP : string = "udeu:status";

export const UDEU_NOTIFICATION_ASPECT : string = "udeu:notificationAsp";
export const UDEU_NOTIFICATION_EMAIL_PROP : string = "udeu:notificationEmail";

export const UDEU_RECIPIENT_ASPECT : string = "udeu:recipientAsp";
export const UDEU_RECIPIENT_NAME_PROP : string = "udeu:recipientName";
export const UDEU_RECIPIENT_EMAIL_PROP : string = "udeu:recipientEmail";

export const UDEU_DOCUMENT_ASPECT : string = "udeu:documentAsp";
export const UDEU_DOCUMENT_CODE_PROP : string = "udeu:docCode";
export const UDEU_DOCUMENT_SIGNATURA_PROP : string = "udeu:docSignatura";
export const UDEU_DOCUMENT_ORDER_PROP : string = "udeu:docOrder";
export const UDEU_DOCUMENT_DIRECTORY_PROP : string = "udeu:docDirectory";
export const UDEU_DOCUMENT_TITLE_PROP : string = "udeu:docTitle";

export const UDEU_LENT_ASPECT : string = "udeu:lentAsp";
export const UDEU_LENT_UUIDS_PROP : string = "udeu:lentUUIDs";

export const BORROWED_RECORD_ASPECT = "udeu:borrowedRecordAsp";
export const UDEU_RECORD_LOANS_UUIDS_PROP : string = "udeu:recordLoansUUIDs";

export const RENEWAL_ASPECT = "udeu:renewalAsp";

export const UDEU_BOUD_ELEMENT_ASPECT : string = "udeu:boudElementAsp";
export const UDEU_BOUD_PROVISION_NUMBER_PROP : string = "udeu:boudProvisionNumber";
export const UDEU_BOUD_NUMBER : string = "udeu:recordBoudNumber";

// Registro GAUDE, valor por defecto
export const UDEU_RECORD_CAMPUS_BILBAO: string = "0";
export const UDEU_RECORD_CAMPUS_SAN_SEBASTIAN: string = "1";

//Bilbao
export const UDEU_RECORD_GAUDE_CAMPUS0_PROV_DEPOSIT: string = "002";
export const UDEU_RECORD_GAUDE_CAMPUS0_LEVEL_DESC: string = "002";
export const UDEU_RECORD_GAUDE_CAMPUS0_SUPPORT_VOLUME: string = "Papel";
export const UDEU_RECORD_GAUDE_CAMPUS0_FUND: string = "001";
export const UDEU_RECORD_GAUDE_CAMPUS0_CLASSIFICATION_GROUP: string = "0008"; //I100
export const UDEU_RECORD_GAUDE_CAMPUS0_CLASSIFICATION: string = "0044"; //I103
export const UDEU_RECORD_GAUDE_CAMPUS0_DIVISON: string = "0131"; //I10301
export const UDEU_RECORD_GAUDE_CAMPUS0_NOMINAL_SUBDIVISION: string = "UD_53";
export const UDEU_RECORD_GAUDE_CAMPUS0_DESCRIPTORS: string[] = ["001"];
export const UDEU_RECORD_GAUDE_CAMPUS0_VALUATION: string = "002";
export const UDEU_RECORD_GAUDE_CAMPUS0_ACCESS: string = "001";
//San Sebastián
export const UDEU_RECORD_GAUDE_CAMPUS1_PROV_DEPOSIT: string = "001";
export const UDEU_RECORD_GAUDE_CAMPUS1_LEVEL_DESC: string = "002";
export const UDEU_RECORD_GAUDE_CAMPUS1_SUPPORT_VOLUME: string = "Papel";
export const UDEU_RECORD_GAUDE_CAMPUS1_FUND: string = "001";
export const UDEU_RECORD_GAUDE_CAMPUS1_CLASSIFICATION_GROUP: string = "0008"; //I100
export const UDEU_RECORD_GAUDE_CAMPUS1_CLASSIFICATION: string = "0044"; //I103
export const UDEU_RECORD_GAUDE_CAMPUS1_DIVISON: string = "0131"; //I10301
export const UDEU_RECORD_GAUDE_CAMPUS1_NOMINAL_SUBDIVISION: string = "UD_53";
export const UDEU_RECORD_GAUDE_CAMPUS1_DESCRIPTORS: string[] = ["001"];
export const UDEU_RECORD_GAUDE_CAMPUS1_VALUATION: string = "002";
export const UDEU_RECORD_GAUDE_CAMPUS1_ACCESS: string = "001";

// Registro FORMACION CONITNUA, valor por defecto
export const UDEU_RECORD_FORMACION_LEVEL_DESC: string = "001";
export const UDEU_RECORD_FORMACION_SUPPORT_VOLUME: string = "Papel";
export const UDEU_RECORD_FORMACION_FUND: string = "001";
export const UDEU_RECORD_FORMACION_CLASSIFICATION_GROUP: string = "0008"; //I100
export const UDEU_RECORD_FORMACION_CLASSIFICATION: string = "0048"; //I107
export const UDEU_RECORD_FORMACION_DIVISON: string = "0145"; //I10703
export const UDEU_RECORD_FORMACION_DESCRIPTORS: string[] = ["023"];
export const UDEU_RECORD_FORMACION_VALUATION: string = "002";
export const UDEU_RECORD_FORMACION_ACCESS: string = "001";
export const UDEU_RECORD_FORMACION_CATEGORIA: string = "0005";

// Soporte
export const UDEU_TRANSFER_PHYSICAL_SUPPORT: string = "01";

// TRANSFER STATUS KEYS
export const UDEU_TRANSFER_PENDING_STATUS: string = "01";
export const UDEU_TRANSFER_DRAFT_STATUS: string = "02";
export const UDEU_TRANSFER_SENDED_STATUS: string = "03";
export const UDEU_TRANSFER_REJECTED_STATUS: string = "04";
export const UDEU_TRANSFER_ACCEPTED_STATUS: string = "05";
export const UDEU_TRANSFER_CATALOGED_STATUS: string = "06";

// LOAN STATUS KEYS
export const UDEU_LOAN_REQUESTED_STATUS: string = "01";
export const UDEU_LOAN_REJECTED_STATUS: string = "02";
export const UDEU_LOAN_IN_PROGRESS_STATUS: string = "03";
export const UDEU_LOAN_BORROWED_STATUS: string = "04";
export const UDEU_LOAN_RETURNED_STATUS: string = "05";
export const UDEU_LOAN_EXPIRED_STATUS: string = "06";
export const UDEU_LOAN_FINISHED_STATUS: string = "07";

// LOAN RENEW STATUS KEYS
export const UDEU_LOAN_RENEW_REQUEST_STATUS: string = "01";
export const UDEU_LOAN_RENEW_APPROVED_STATUS: string = "02";
export const UDEU_LOAN_RENEW_REJECTED_STATUS: string = "03";

// BOUD STATUS KEYS
export const UDEU_BOUD_DRAFT_STATUS: string = "01";
export const UDEU_BOUD_READY_STATUS: string = "02";
export const UDEU_BOUD_VALIDATED_STATUS: string = "03";
export const UDEU_BOUD_PUBLISHED_STATUS: string = "04";
export const UDEU_BOUD_PUBLISHED_MODIFIED_STATUS: string = "05";
export const UDEU_BOUD_PUBLISHED_SUSPENDED_STATUS: string = "06";
export const UDEU_BOUD_PUBLISHED_REPEALED_STATUS: string = "07";

// BOUD ACTION TYPE KEYS
export const UDEU_BOUD_PARTIAL_REPEALING_ACTION: string = "007";

// BOUD RULES
export const UDEU_BOUD_POLICY_TYPES: string[] = ["001", "002"];
export const UDEU_BOUD_RESOLUTIONS_TYPE: string = "002";
export const UDEU_BOUD_UD_DISPOSITION_TYPE: string = "016";

//RECORD TYPOLOGY KEYS
export const UDEU_RECORD_EXPEDIENTE_TYPOLOGY_KEY = "0019";

//RECORD TITLE KEYS
export const UDEU_RECORD_STUDENT_TITLE_KEY = "0125";
export const UDEU_RECORD_TRAINING_TITLE_KEY = "0134";

//BOUD PRODUCING BODY KEYS
export const UDEU_BOUD_FACULTY_PRODUCING_KEY = "004";